import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

import Loader from "../../components/Loader";
import { useAuth } from "../../services/wp.auth.service";

const Logout = () => {
	const { logout } = useAuth();

	const navigate = useNavigate();

	useEffect(async () => {
		await logout();
		navigate("/login");
	}, []);

	return <Loader />;
};

export default Logout;
